import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';

export interface CheckboxButtonProps {
  className?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  children?: ReactNode;
}

export function CheckboxButton({
  className,
  checked,
  onChange,
  disabled,
  children,
}: Readonly<CheckboxButtonProps>): ReactElement<CheckboxButtonProps> {
  const handleClick = onChange && (() => onChange(!checked));

  return (
    <button
      className={clsx(
        `min-w-auto bg-grey-100 m-0 min-h-[42px] w-full max-w-full rounded-none border-none font-semibold leading-none aria-checked:bg-green-200 aria-checked:text-white ${className}`,
        { 'hover:bg-grey-100/50 aria-checked:hover:bg-green-300': !disabled },
      )}
      role="checkbox"
      aria-checked={checked ?? false}
      color={checked ? 'primary' : 'inherit'}
      onClick={handleClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
